<template>
  <div>
    <Header />
    <Details :currentUserMap="currentUserMap" />
    <Footer />
    <SocialLinks :noDisplayMobile="true" />
  </div>
</template>

<script>
  import Header from '../components/common/Header'
  import Details from '../components/ExecDetails/Details'
  import Footer from '../components/common/Footer'
  import SocialLinks from '../components/common/SocialLinks'

  export default {
    name: 'ExecDetails',
    metaInfo: {
      title: 'About Us',
    },
    computed: {
      currentUserMap() {
        return this.$store.state.executives.find(executive => 
          executive.slug == this.$route.params.slug)
      }
    },
    components: {
      Header,
      Details,
      Footer,
      SocialLinks
    },
    watch: {
      $route(to) {
        this.currentUser = to
      }
    }
  }
</script>

<style>
</style>